import {
    Box,
    Button,
    CircularProgress,
} from '@mui/material';
import { darken } from "@mui/system";

const SendNewLinkMessage = ({ loading, sendNewLink, message }) => {
    return (
        <Box sx={{width: {xs: '92%', sm: '97%'}}}>
            <Box 
                className="attention" 
                sx={{
                    display: 'flex', 
                    width: '100%', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    fontSize: '1.1rem', 
                    p: 2,
                    backgroundColor: '#E84545', 
                    color: 'white', 
                    borderRadius: '20px',
                    flexDirection: {xs: 'column', sm: 'row'}, 
                    gap: {xs: 2, sm: 0}
                }}
            >
                <Box>
                    {message}
                </Box>
                {
                    loading ?
                    <Box sx={{marginLeft: {sm: 'auto'}}}>
                        <CircularProgress size={30}/>
                    </Box> :
                    <Button 
                        variant='contained' 
                        color="secondary"
                        sx={{
                            backgroundColor: '#942c2c', 
                            marginLeft: {sm: 'auto'}, 
                            width: {xs: '100%', sm: 'auto'},
                            textTransform: "none", 
                            fontWeight: 'bold',
                            '&:hover': {
                                backgroundColor: darken('#942c2c', 0.2), // Darkens by 20%
                            }
                        }}
                        onClick={sendNewLink}
                    >
                        Send new link
                    </Button>
                }
            </Box>
        </Box>
    );
}

export default SendNewLinkMessage;